// extracted by mini-css-extract-plugin
export default {"dropImagePlaceholder":"NgsVR","iconAndTitle":"LuEYI","imagePlaceholderTips":"Tt8FD","fullImage":"yZUvl"};